module.exports = __webpack_public_path__ + "static/media/cloudy-day-1.80a5d865.svg";